module.exports = __webpack_public_path__ + "img/inge-v9-char-2.f254e761.png";